'use client';

import UserAvatar from 'layouts/app/UserAvatar';
import Button from 'layouts/institucional/Button';

interface HeaderButtonsProps {
	isMobile?: boolean;
	isAuthenticated?: boolean;
}

function HeaderButtons(props: HeaderButtonsProps) {
	if (props.isAuthenticated) return <UserAvatar size={38} />;

	return (
		<>
			<Button
				variant={!props.isMobile ? 'text' : 'outlined'}
				linkTo="auth.login"
				linkProps={{
					'aria-label': 'Entrar na sua conta',
				}}
			>
				Entrar
			</Button>

			<Button
				variant="default"
				linkTo="auth.register"
				linkProps={{
					'aria-label': 'Criar conta grátis',
				}}
			>
				Criar conta grátis
			</Button>
		</>
	);
}

export default HeaderButtons;
